"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toWeiBN = exports.isValidValue = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var web3_1 = __importDefault(require("web3"));
var web3_utils_1 = require("web3-utils");
var isValidValue = function (value) {
    var normalized = value.trim();
    if (!value || !value.match(/^-?[0-9.]+$/)) {
        return false;
    }
    try {
        new bn_js_1.default((0, web3_utils_1.toWei)(normalized));
        return true;
    }
    catch (e) {
        return false;
    }
};
exports.isValidValue = isValidValue;
var toWeiBN = function (value) {
    if (value === "" || value === Infinity || value === "Infinity") {
        value = 0;
    }
    try {
        var pure = String(value).replace(/,/g, "");
        return web3_1.default.utils.toBN(web3_1.default.utils.toWei(pure));
    }
    catch (e) {
        console.error("toWeiBN failed to convert BN", value, e);
        return new bn_js_1.default("0");
    }
};
exports.toWeiBN = toWeiBN;
